import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import { useT } from '_metronic/i18n/Metronici18n'
import { AvaliacoesPendentesListWrapper } from './avaliacoes-pendentes-list/AvaliacoesPendentesList'
import { AvaliacoesListWrapper } from './avaliacoes-list/AvaliacoesList'

const AvaliacoesPage = () => {
  const { t } = useT()
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='pendentes/lista'
          element={
            <>
              <PageTitle description={t('pagina.avaliacoesPendentes.descricao')}>
                Avaliações Pendentes
              </PageTitle>
              <AvaliacoesPendentesListWrapper />
            </>
          }
        />
        <Route
          path='lista'
          element={
            <>
              <PageTitle description={t('pagina.avaliacoes.descricao')}>Avaliações</PageTitle>
              <AvaliacoesListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/avaliacoes' />} />
    </Routes>
  )
}

export default AvaliacoesPage
